import { WarningTwoIcon } from '@chakra-ui/icons';
import { Box, CloseButton, Text } from '@chakra-ui/react';
import { useState } from 'react';

type BoxXriticalProps = {
  isCritical?: boolean;
  textContent: string;
  maxWidth?: string;
};

export const BoxCritical = ({
  isCritical = true,
  textContent,
  maxWidth
}: BoxXriticalProps) => {
  const [onClose, setOnClose] = useState(isCritical);

  return (
    <>
      {onClose && (
        <Box
          data-testid="box-element"
          bg="#F6E7B1"
          borderRadius="6px"
          maxW={maxWidth ? maxWidth : ''}
          m="20px 0 0 0 !important"
          w="100%"
          p="16px"
          display="flex"
          gap="16px"
          alignItems="center"
          justifyContent="space-between"
        >
          <WarningTwoIcon w="24px" h="20px" color="#434343" />
          <Text
            w="100%"
            textAlign="start"
            fontSize="1rem"
            fontWeight="400"
            lineHeight="1.5rem"
          >
            {textContent}
          </Text>
          <CloseButton
            m="0 !important"
            w="15px"
            h="15px"
            color="#434343"
            onClick={() => {
              setOnClose(!onClose);
            }}
            _hover={{}}
            _active={{}}
            _focus={{
              '&:focus': {
                boxShadow: 'none !important'
              }
            }}
          />
        </Box>
      )}
    </>
  );
};
